import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Component } from 'react';
import { noop } from 'lodash';
import { logError } from 'libs/utils/window';
import AppError from './AppError';
import ComponentError from './ComponentError';
import LayoutError from './LayoutError';
import { jsx as _jsx } from "react/jsx-runtime";
const initialState = {
  hasError: false,
  error: null,
  errorInfo: null
};

class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", _objectSpread({}, initialState));

    _defineProperty(this, "handleRetry", () => this.setState(_objectSpread({}, initialState)));
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  componentDidCatch(error, errorInfo) {
    const {
      onError,
      preventLog
    } = this.props;
    this.setState({
      error,
      errorInfo
    });

    if (!preventLog) {
      logError(error);
    }

    return onError(error);
  }

  render() {
    const {
      hasError,
      error,
      errorInfo
    } = this.state;
    const {
      FallbackComponent,
      children
    } = this.props;

    if (hasError) {
      if (!FallbackComponent) return null;
      return /*#__PURE__*/_jsx(FallbackComponent, {
        error: error,
        errorInfo: errorInfo,
        handleRetry: this.handleRetry
      });
    }

    return children;
  }

}

_defineProperty(ErrorBoundary, "AppError", AppError);

_defineProperty(ErrorBoundary, "ComponentError", ComponentError);

_defineProperty(ErrorBoundary, "LayoutError", LayoutError);

_defineProperty(ErrorBoundary, "defaultProps", {
  preventLog: false,
  onError: noop
});

export default ErrorBoundary;